import { mapCollection, sortByString } from '../../utils/collection.utils';
import { Option } from '../option';
import { OptionText } from '../option-text';

export class OptionBuilder {
  static fromJson(json: any) {
    return (json)
      ? new Option(
        json.key,
        json.value
      )
      : null;
  }

  static fromList(list) {
    const options = mapCollection(OptionBuilder.fromJson, list).sort();
    return sortByString('value', options);
  }

  static getOptionTextFromJson(json: any) {
    return (json)
      ? new OptionText(
        json.key,
        json.value,
        ''
      )
      : null;
  }

  static getOptionTextfromList(list) {
    return mapCollection(OptionBuilder.getOptionTextFromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/option.builder.ts